'use es6';

import { FetchRetailRequestTypes } from '../actions/RetailActions';

const Retail = (state = false, {
  type,
  payload
}) => {
  switch (type) {
    case FetchRetailRequestTypes.RECEIVE:
      return payload.data;

    default:
      return state;
  }
};

export default Retail;